import axios from "axios";
import { URL } from './url';

function authenticate(credentials) {
    return axios.post(URL + "/server.php?action=connexion", credentials)
        .then(response => response.data)
        .then(data => {
            if (data.id !== undefined) {
                window.localStorage.setItem("id", data.id);
                window.localStorage.setItem("codeInter", data.codeInter);
                window.localStorage.setItem("role", data.role);
            }
        })
}

function isAuth() {
    let log = window.localStorage.getItem('id');
    return (log != null && log !== undefined);
}

export default {
    authenticate,
    isAuth
}